import { Chip, TableCell, TableRow, Typography } from "@mui/material";
import type { FC } from "react";
import type { InactiveCustomerRow } from "../statisticsApi";
import { formatContactCalculations } from "../statisticsFormat";
import ReportTable, { CustomerLink } from "./ReportTable";

const STATUS_LABELS: Record<InactiveCustomerRow["status"], string> = {
  ACTIVE: "Active",
  ACTIVE_LEAD: "Active Lead",
};

const COLUMNS = [
  { label: "Klient" },
  { label: "Status" },
  { label: "Zamówienia w okresie", align: "right" as const },
  { label: "Kalkulacje", align: "right" as const },
];

interface Props {
  readonly rows: InactiveCustomerRow[];
}

const InactiveCustomersTable: FC<Props> = ({ rows }) => {
  if (rows.length === 0) {
    return <Typography sx={{ color: "text.secondary" }}>Brak nieaktywnych klientów w wybranym okresie</Typography>;
  }
  return (
    <ReportTable columns={COLUMNS}>
      {rows.map((row) => (
        <TableRow key={row.customerId} hover>
          <TableCell>
            <CustomerLink customerId={row.customerId} customerName={row.customerName} />
          </TableCell>
          <TableCell>
            <Chip
              label={STATUS_LABELS[row.status]}
              size="small"
              variant="outlined"
              color={row.status === "ACTIVE_LEAD" ? "success" : "primary"}
            />
          </TableCell>
          <TableCell align="right">0</TableCell>
          <TableCell align="right">{formatContactCalculations(row.calculations)}</TableCell>
        </TableRow>
      ))}
    </ReportTable>
  );
};

export default InactiveCustomersTable;
